import {createSlice} from '@reduxjs/toolkit'

export const bulkModifiersInitialState = {
  bulkModifierName: '',
  storeSelector: '',
  actions: '',
  numberOfDays: '',
  numberOfPoints: '',
  schedule: '',
  startDate: '',
  endDate: '',
}

const bulkModifiersSlice = createSlice({
  name: 'bulkModifiers',
  initialState: bulkModifiersInitialState,
  reducers: {
    setBulkModifiers: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    resetBulkModifiers: () => bulkModifiersInitialState,
  },
})

export const {setBulkModifiers, resetBulkModifiers} = bulkModifiersSlice.actions

export const bulkModifiersSliceReducer = bulkModifiersSlice.reducer
